<script setup>
// The /news page in Trailhead: the design's page header, then the
// posts as a featured article over a grid. Built from the same two
// blocks a manager can place on any page, so the index cannot drift
// from them.
import ThPageHeader from './ThPageHeader.vue';
import ThNews from './ThNews.vue';

defineProps({
    posts: { type: Array, default: () => [] },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

const HEADER = {
    tone: 'tint',
    eyebrow: 'News & updates',
    title: 'News',
    subtitle: 'Trail updates, ride reports and announcements.',
};
const NEWS = { source: 'auto', layout: 'featured', max_posts: 'all' };
</script>

<template>
    <ThPageHeader :config="HEADER" :accent="accent" :org="org" />
    <ThNews class="th-index" :config="NEWS" :accent="accent" :org="org" :site_data="{ news_posts: posts }" />
</template>

<style scoped>
/* The design's index sections sit closer to the header than a block
   on a page does, and end on a full band of space before the footer. */
.th-sec.th-index { padding-top: clamp(32px, 5vw, 56px); padding-bottom: clamp(48px, 7vw, 96px); }
</style>
